import { useState } from "react";
import axios from "axios";
import { PaperPlaneTilt, CheckCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Failed to send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="bg-emerald-600/10 border border-emerald-600/40 rounded-2xl p-8 text-center"
           data-testid="contact-sent">
        <CheckCircle size={40} weight="duotone" className="text-emerald-400 mx-auto mb-3" />
        <p className="text-lg font-heading font-semibold text-white">Message received</p>
        <p className="text-sm text-stone-400 mt-1">We will reply within two business days.</p>
        <button onClick={() => setSent(false)}
          className="mt-4 text-xs text-emerald-400 hover:text-emerald-300 underline">
          Send another message
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3 bg-stone-900 rounded-2xl border border-stone-800 p-6"
          data-testid="contact-form">
      <h3 className="font-heading text-lg font-semibold text-white mb-2">Send us a message</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Your name" data-testid="contact-name"
          className="bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500" />
        <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="you@example.com" data-testid="contact-email"
          className="bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500" />
      </div>
      <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
        placeholder="Subject (optional)" data-testid="contact-subject"
        className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500" />
      <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
        placeholder="How can we help?" data-testid="contact-message"
        className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-stone-100 focus:outline-none focus:border-emerald-500" />
      {err && <p className="text-xs text-red-400" data-testid="contact-err">{err}</p>}
      <button type="submit" disabled={sending}
        className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white text-sm font-medium px-5 py-2.5 rounded-lg inline-flex items-center gap-2"
        data-testid="contact-submit">
        <PaperPlaneTilt size={14} weight="bold" /> {sending ? "Sending…" : "Send message"}
      </button>
    </form>
  );
}
